module.exports = __webpack_public_path__ + "img/OA.c3a8a79d.png";